import { ADMIN_SCOPED_ROLES, getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { IOneReport } from './types/IOneReport';

interface IUpdateOneReportMedia {
  assessments?: string;
  internal_notes?: string;
  chief_complaint_problem?: string;
  pain_scale?: number;
  medical_history?: string;
  is_media_utilized?: boolean;
  is_intra_oral_utilized?: boolean;
  is_extra_oral_utilized?: boolean;
  disposition?: string;
  prescription_in_icore?: string;
  pharmacy?: string;
  need_for_oral_health_coaching?: string;
  cdts?: string[];
  is_terms_accepted?: boolean;
}

// Admin/SuperAdmin/OrganizationAdmin use the dedicated `/admin/one_reports/...`
// router (inline role + org gates). Other staff roles reach this endpoint via
// their scoped prefix; Patient/Provider (read-only/edit-flow-locked here) fall
// through to the unprefixed route, which gates them out via permissions.
export const updateOneReport = async (
  one_report_id: string,
  payload: IUpdateOneReportMedia,
  userRole?: string,
): Promise<IOneReport> => {
  const url =
    userRole && ADMIN_SCOPED_ROLES.has(userRole)
      ? `/admin/one_reports/${one_report_id}`
      : `${getStaffScopedApiPrefix(userRole)}/one_reports/${one_report_id}`;
  const { data } = await client.patch<IOneReport>(url, payload);

  return data;
};
